<template class="additionalNumber">
    <tbody>
        <!-- Get a new number -->
        <tr v-if="position > 0">
            <th colspan="2">
                <label class="font-weight-bold text-uppercase">Additional number setup {{position + 1}}</label>
                <div
                    class="btn btn-danger btn-sm float-right"
                    @click="$emit('deleteNumber', position)" >
                    <i class="fas fa-trash-alt"></i>
                </div>
            </th>
        </tr>
        <tr>
            <th>Area Code</th>
            <td>
                <div class="form-group" :class="{error: $v.number.$error && !$v.number.area_code.required}">
                    <select class="form-control" v-model="number.area_code" >
                        <option value="">-- Select an area code --</option>
                        <optgroup
                          v-for="(code, key) in areaCodes"
                          :key="key"
                          :label="key | capitalize"
                        >
                            <option
                                :value="codeItem.id"
                                v-for="codeItem in code"
                                :key="codeItem.id"
                                >{{ codeItem.prefix }} -
                                {{ codeItem.description }}</option
                            >
                        </optgroup>
                    </select>
                    <p class="help-block" v-if="$v.number.$error && !$v.number.area_code.required"><i class="fas fa-exclamation-triangle"></i> Please select an area code.</p>
                </div>
            </td>
        </tr>
        <tr v-if="service != 'voipLineService'">
            <th>Selection</th>
            <td>
                <div class="form-group" :class="{error: $v.number.$error && !$v.number.number_selection.required}">
                    <!-- First -->
                    <label :for="'new-individual-number-' + position" class="option-input-label"><input type="radio" class="mr-2 option-input input-xs with-check radio" :id="'new-individual-number-' + position" value="individual" v-model="number.number_selection"/>Individual Number</label>   

                    <!-- Second -->
                    <label :for="'new-range-' + position" class="option-input-label"><input type="radio" class="mr-2 option-input input-xs with-check radio" :id="'new-range-' + position" value="range" v-model="number.number_selection"/>Number range</label>
                     
                    <p class="help-block" v-if="$v.number.$error && !$v.number.number_selection.required"><i class="fas fa-exclamation-triangle"></i> Please select an option.</p>
                </div>
            </td>
        </tr>
        <tr v-if="number.number_selection == 'range'">
            <th>Number of direct dial numbers</th>
            <td>
                <div class="form-group" :class="{error: $v.number.number_range.$error}">
                    <input type="number" class="form-control" v-model="number.number_range"  v-on:blur="validateRange"/>
                    <small class="d-block mt-2"><i class="fas fa-info-circle color-info"></i> Ranges must be provisioned in multiples of ten.
                     Non-multiples shall be rounded upwards. (E.g. 11 will be rounded to 20.)</small>
                    <p class="help-block" v-if="$v.number.$error && !$v.number.number_range.required"><i class="fas fa-exclamation-triangle"></i> Please select an area code.</p>
                    <p class="help-block" v-if="$v.number.$error && !$v.number.number_range.minValue"><i class="fas fa-exclamation-triangle"></i> Please enter a valid number range starting from 10.</p>
                 </div>
            </td>
        </tr>
    </tbody>
  
</template>

<script>

import { required, requiredIf, minLength, between, email, helpers } from 'vuelidate/lib/validators'

export default {
    name: "AdditionalNumber",
    props: {
        areaCodes: {
            required: true
        }, 
        number: {
            type: Object,
            required: true,
        }, 
        position: {
            type: Number,
            required: true,
        }, 
        service: {
            type: String,
            required: true,
        }, 
        validate: {
            type: Number,
            required: true,
        }, 
        completingSection: {
            type: Boolean,
            required: true,
        }
    },
    data() {
         return {};
    },

    /**
     * Vuelidate validation rules
     * 
     * @type {Object}
     */
    validations:{
        number: {
            area_code: {
                required: requiredIf(function(){
                    return this.completingSection;
                })
            },
            number_selection: {
                required: requiredIf(function(){
                    return this.completingSection && this.service != 'voipLineService';
                })
            },
            number_range: {
                required: requiredIf(function(){
                    return this.completingSection && this.number.number_selection == 'range';
                }),
                minValue:function(value){

                    return !helpers.req(value) || value >= 10 || this.number.number_selection != 'range';
                }
            },
        },
    },
    watch: {
       
        'number.number_selection': function(){
            if(this.number.number_selection != '' && this.number.number_selection == 'individual'){
                this.number.number_range = null;
            }
        },
        'number.area_code': function(){
            if(this.service == 'voipLineService'){
                this.number.number_selection = 'individual';
            }
        },
        validate: function(){
            this.$v.number.$touch();
        },

    },
    methods: {
        /**
         * Validate number of channels based on number selection
         */
        validateRange: function(){
            if(this.number.number_range > 10 && !this.isValidRange(this.number.number_range)){

                var message = 'Each range must be a multiple of ten.';

                Swal.fire({
                          title: 'Error!',
                          html: message,
                          icon: 'info',
                          confirmButtonText: 'Okay'
                        });

                this.number.number_range = this.roundUpRange(this.number.number_range);
            }
        },
        
        /**
         * Valid ranges must be multiple of ten
         * @return boolean
         */
        isValidRange: function(value){
            return value % 10 == 0;
        },

        roundUpRange: function(value){
            return Math.ceil(value / 10) * 10;
        }
    }

};
</script>
